import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { SignedDocumentStatus } from "@wingspanhq/signed-documents/dist/lib/interfaces/signedDocument";
import { WSEmptyStateProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSEmptyState/WSEmptyState";
import { mapStatusesToCardDetails } from "../../../../helpers/mapStatusesToCardDetails";

export const payeeSignatureRenderCardDescription = (
  requirement: IRequirementResponse,
  signedDocument?: ISignedDocumentResponse
) => {
  const signedDocumentDescriptions: Record<
    SignedDocumentStatus,
    WSEmptyStateProps
  > = {
    [SignedDocumentStatus.New]: {
      type: "documents",
      title: "The file is being prepared by you",
      description:
        "Once it is ready, it will be sent to the contractor for signature."
    },
    [SignedDocumentStatus.Sent]: {
      type: "documents",
      title: "Document sent for signature",
      description:
        "The document has been delivered to the contractor for their signature."
    },
    [SignedDocumentStatus.Pending]: {
      type: "documents",
      title: "Document requires countersignature",
      description:
        "The contractor has signed the document. Please review and countersign to complete the process."
    },
    [SignedDocumentStatus.Complete]: {
      type: "done",
      title: "The e-signature document is complete",
      description:
        "All signatures have been collected. The fully executed document is available for download."
    }
  };

  return mapStatusesToCardDetails({
    requirement,
    documentStatus: signedDocument?.status || SignedDocumentStatus.New,
    documentStatuses: signedDocumentDescriptions,
    pendingApprovalStatus: {
      type: "documents",
      title: "Document pending your approval",
      description:
        "All signatures have been collected. The requirement now requires your approval or rejection."
    },
    approvedStatus: null,
    rejectedStatus: {
      type: "documents",
      title: "Document was rejected",
      description:
        "The requirement was rejected and may affect the contractor’s eligibility for related engagements."
    }
  });
};
